var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "calendar-item" }, [
    _c("span", {
      staticClass: "bullit",
      style: { backgroundColor: _vm.color },
    }),
    _c("div", { staticClass: "timestamp" }, [
      _vm._v(" " + _vm._s(_vm.dateString) + " "),
    ]),
    _c("div", { staticClass: "title" }, [
      _vm._v(" " + _vm._s(_vm.title) + " "),
    ]),
    _vm.location
      ? _c(
          "div",
          { staticClass: "location" },
          [
            _c("w-fa", {
              staticClass: "mrs",
              attrs: { icon: "map-marker-alt" },
            }),
            _vm._v(_vm._s(_vm.location) + " "),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }